module.exports = __webpack_public_path__ + "pencil.46c0ea70227ee468c4f5.png";